const moment = require("moment");
const store = require("../store/index.js");
const pub = {
  // checkAuth(str) {
  //   let arr = store.default.state.userInfo.role.split(",");
  //   let str_arr = str.split(",");
  //   for (let i = 0; i < str_arr.length; i++) {
  //     let s = str_arr[i];
  //     let role = "-1";
  //     if (s === "前台") {
  //       role = "1";
  //     } else if (s === "医助") {
  //       role = "2";
  //     } else if (s === "医生") {
  //       role = "3";
  //     } else if (s === "店长") {
  //       role = "4";
  //     } else if (s === "采购") {
  //       role = "5";
  //     } else if (s === "管理员") {
  //       role = "100";
  //     } else if (s === "活体主管") {
  //       role = "6";
  //     } else if (s === "产品运营") {
  //       role = "7";
  //     }
  //     if (
  //       arr.findIndex(function(item) {
  //         if (item === "0" || item === "") {
  //           item === "1";
  //         }
  //         return item == role;
  //       }) > -1
  //     ) {
  //       return true;
  //     }
  //   }
  //   return false;
  // },
  formatOrderState(state) {
    let result = "";
    if (state === 0) {
      result = "已删除";
    } else if (state === 1) {
      result = "已创建";
    } else if (state === 2) {
      result = "支付中";
    } else if (state === 3) {
      result = "支付成功";
    } else if (state === 4) {
      result = "已接单";
    } else if (state === 5) {
      result = "已发货";
    } else if (state === 8) {
      result = "已完成";
    } else if (state === -2) {
      result = "已取消";
    } else if (state === -3) {
      result = "退换中";
    } else if (state === -4) {
      result = "退换成功";
    } else if (state === 11) {
      result = "待付款";
    } else if (state === 12) {
      result = "待发货";
    } else if (state === 13) {
      result = "待收货";
    } else if (state === 14) {
      result = "待评价";
    } else if (state === 15) {
      result = "退货";
    } else {
      result = "未知";
    }
    return result;
  },
  formatState(state) {
    let result = "";
    if (state === 1) {
      result = "已申请";
    } else if (state === 2) {
      result = "审核中";
    } else if (state === 3) {
      result = "处理成功";
    } else if (state === -1) {
      result = "审核失败";
    } else if (state === -2) {
      result = "已取消";
    }
    return result;
  },
  //换宠
  formatoweState(state) {
    let result = "";
    if (state === 0) {
      result = "无欠宠";
    } else if (state === 1) {
      result = "欠宠中";
    } else if (state === 2) {
      result = "换宠中";
    } else if (state === 3) {
      result = "已完成";
    } else if (state === 4) {
      result = "已退款";
    }
    return result;
  },
  formatOrderReturnState(state) {
    let result = "";
    if (state === 0) {
      result = "已删除";
    } else if (state === 1) {
      result = "已申请";
    } else if (state === 2) {
      result = "已审核";
    } else if (state === 3) {
      result = "退换中";
    } else if (state === 4) {
      result = "已收货";
    } else if (state === 8) {
      result = "已完成";
    } else if (state === -2) {
      result = "已取消";
    } else {
      result = "未知";
    }
    return result;
  },
  formatPayTypeState(state) {
    let result = "";
    if (state === 0) {
      result = "现金";
    } else if (state === 1) {
      result = "线上支付宝";
    } else if (state === 2) {
      result = "线上微信";
    } else if (state === 3) {
      result = "线下支付宝";
    } else if (state === 4) {
      result = "线下微信";
    } else if (state === 5) {
      result = "pos";
    } else if (state === 6) {
      result = "找零";
    } else if (state === 7) {
      result = "余额";
    } else if (state === 8) {
      result = "赠额";
    } else if (state === 9) {
      result = "积分";
    } else if (state === 10) {
      result = "押金";
    } else if (state === 11) {
      result = "电商平台";
    } else if (state === 12) {
      result = "优惠";
    } else if (state === 13) {
      result = "京东聚合";
    } else if (state === 17) {
      result = "拉卡拉";
    } else if (state === 14) {
      result = "订金";
    } else if (state === 15) {
      result = "嘉联";
    } else if (state === 16) {
      result = "礼品卡";
    } else {
      result = "未知";
    }
    return result;
  },
  // 回访类型
  getReturnVisitType(state) {
    let result = "";
    if (state === 1) {
      result = "crm客户回访";
    } else if (state === 2) {
      result = "待跟进客户回访";
    } else if (state === 3) {
      result = "病例回访";
    } else if (state === 4) {
      result = "订单回访";
    } else {
      result = "未知";
    }
    return result;
  },
  // 计算用量单价
  getCFPrice(stete, str, num) {
    if (stete === 0) {
      return this.chu(num, str);
    } else {
      return num;
    }
  },
  // 计算小计
  getSubtotal(row, isOriginal) {
    // isOriginal：true 按原价算小计
    let subtotal = 0;
    if (row.allow_wholesale === 1 || row.allowWholesale === 1) {
      if (isOriginal === true) {
        subtotal = this.cheng(row.originalPrice, row.num);
      } else {
        subtotal = this.cheng(row.price, row.num);
      }
    } else {
      if (row.dosageCeiling === 1) {
        if (row.dosageCeilingValue !== 0) {
          row.countPriceDosage = this.cheng(
            parseInt(row.goodsDosage / row.dosageCeilingValue) +
              (this.quyu(row.goodsDosage, row.dosageCeilingValue) === 0
                ? 0
                : 1),
            row.dosageCeilingValue
          );
        } else {
          row.countPriceDosage = row.goodsDosage;
        }
      } else {
        row.countPriceDosage = row.goodsDosage;
      }
      if (isOriginal === true) {
        subtotal = this.cheng(row.originalPrice, row.countPriceDosage);
      } else {
        subtotal = this.cheng(row.price, row.countPriceDosage);
      }
    }
    return subtotal;
  },
  // 补全条码
  completeScanningCode(str) {
    let len = str.length;
    if (len == 12) {
      return str;
    } else if (len > 12) {
      alert("条码输入有误");
    } else {
      let result = "1";
      for (let i = 0; i < 11 - len; i++) {
        result = result + "0";
      }
      return result + str;
    }
  },
  // 判断非五家门店
  getShopStore(shopId) {
    if (
      shopId === "5e9412e0b2bfbc089daerr12" ||
      shopId === "5e9412e0b2bfbc089daerr13" ||
      shopId === "5e9412e0b2bfbc089daerr15" ||
      shopId === "5e9412e0b2bfbc089daerr16" ||
      shopId === "5e9412e0b2bfbc089daerr18"
    ) {
      return true;
    } else {
      return false;
    }
  },
  // 获取当前门店
  getShopNameById(shopId) {
    let shopName = "";
    if (shopId === "5e9412e0b2bfbc089daerr12") {
      shopName = "北环";
    } else if (shopId === "5e9412e0b2bfbc089daerr13") {
      shopName = "陇海";
    } else if (shopId === "5e9412e0b2bfbc089daerr14") {
      shopName = "指挥中心";
    } else  if (shopId === "5e9412e0b2bfbc089daerr16") {
      shopName = "二七";
    } else if (shopId === "5e9412e0b2bfbc089daerr17") {
      shopName = "线上旗舰";
    } else if (shopId === "5e9412e0b2bfbc089daerr18") {
      shopName = "云尚";
    } else if (shopId === "5e9412e0b2bfbc089daerr10") {
      shopName = "驯养中心";
    } else if (shopId === "5e9412e0b2bfbc089daerr11") {
      shopName = "小程序";
    }
    return shopName;
  },
  // 遍历规格名称
  FSkuCard(arr) {
    let arr1 = [];
    for (let i = 0; i < arr.length; i++) {
      let skus = JSON.parse(arr[i].skus);
      let skuValue = "";
      for (let skusItemIndex in skus) {
        skuValue = skuValue + "," + skus[skusItemIndex].value;
      }
      if (skuValue.length > 0) {
        skuValue = skuValue.substr(1, skuValue.length);
      }
      let shop_stock = arr[i].shop_stock;
      let stock = 0;
      for (let a = 0; a < shop_stock.length; a++) {
        if (shop_stock[a].shop_id == store.default.state.shopId) {
          stock = shop_stock[a].shop_stock;
        }
        if (shop_stock[a].shop_id === "5e9412e0b2bfbc089daerr12") {
          shop_stock[a].shopName = "北环";
        } else if (shop_stock[a].shop_id === "5e9412e0b2bfbc089daerr13") {
          shop_stock[a].shopName = "陇海";
        } else if (shop_stock[a].shop_id === "5e9412e0b2bfbc089daerr14") {
          shop_stock[a].shopName = "指挥中心";
        } else if (shop_stock[a].shop_id === "5e9412e0b2bfbc089daerr16") {
          shop_stock[a].shopName = "二七";
        } else if (shop_stock[a].shop_id === "5e9412e0b2bfbc089daerr17") {
          shop_stock[a].shopName = "线上旗舰";
        } else if (shop_stock[a].shop_id === "5e9412e0b2bfbc089daerr10") {
          shop_stock[a].shopName = "驯养中心";
        } else if (shop_stock[a].shop_id === "5e9412e0b2bfbc089daerr11") {
          shop_stock[a].shopName = "小程序";
        }
      }
      arr1.push({
        pprice: arr[i].pprice,
        skuValue: skuValue,
        skus: arr[i]._id,
        stock: stock,
        shop_stock: arr[i].shop_stock,
      });
    }
    return arr1;
  },
  calcActivity(activityItem, price, num) {
    if (activityItem.consume_type === 1) {
      //满减
      let redu = activityItem.full_reduction;
      if (redu.full_reduction_type === 1) {
        // 按金额
        if (redu.full_reduction_conditions <= price) {
          let newPrice = this.jian(price, redu.full_reduction_value);
          return {
            state: true,
            type: "byMoney",
            limit: redu.full_reduction_conditions,
            gift: {},
            newPrice: newPrice < 0 ? 0 : newPrice,
          };
        } else {
          return {
            state: false,
            type: "byMoney",
            limit: redu.full_reduction_conditions,
            gift: {},
            newPrice: price,
          };
        }
      } else {
        // 按数量
        if (redu.full_reduction_conditions <= num) {
          let newPrice = this.jian(price, redu.full_reduction_value);
          return {
            state: true,
            type: "byNumber",
            limit: redu.full_reduction_conditions,
            gift: {},
            newPrice: newPrice < 0 ? 0 : newPrice,
          };
        } else {
          return {
            state: false,
            type: "byNumber",
            limit: redu.full_reduction_conditions,
            gift: {},
            newPrice: price,
          };
        }
      }
    } else if (activityItem.consume_type === 2) {
      //满赠
      let redu = activityItem.full_give;
      if (redu.full_give_type === 1) {
        // 按金额
        if (redu.full_give_conditions <= price) {
          return {
            state: true,
            type: "byMoney",
            limit: redu.full_give_conditions,
            gift: activityItem.give_goods,
            newPrice: price,
          };
        } else {
          return {
            state: false,
            type: "byMoney",
            limit: redu.full_give_conditions,
            gift: activityItem.give_goods,
            newPrice: price,
          };
        }
      } else {
        // 按数量
        if (redu.full_give_conditions <= num) {
          return {
            state: true,
            type: "byNumber",
            limit: redu.full_give_conditions,
            gift: activityItem.give_goods,
            newPrice: price,
          };
        } else {
          return {
            state: false,
            type: "byNumber",
            limit: redu.full_give_conditions,
            gift: activityItem.give_goods,
            newPrice: price,
          };
        }
      }
    } else if (activityItem.consume_type === 3) {
      //折扣
      let newPrice = this.cheng(
        price,
        activityItem.other_info.other_info_value
      );
      return {
        state: true,
        type: "none",
        limit: 0,
        gift: {},
        newPrice: newPrice,
      };
    } else if (activityItem.consume_type === 4) {
      //立减
      let newPrice = this.jian(price, activityItem.other_info.other_info_value);
      return {
        state: true,
        type: "none",
        limit: 0,
        gift: {},
        newPrice: this.cheng(newPrice, num),
      };
    } else if (activityItem.consume_type === 5) {
      //定价
      let newPrice = activityItem.other_info.other_info_value;
      return {
        state: true,
        type: "none",
        limit: 0,
        gift: {},
        newPrice: this.cheng(newPrice, num),
      };
    }
  },
  calcAfterCoupon(totalMoney, curDiscountCard) {
    if (curDiscountCard.activity_type === 1) {
      // 满减
      totalMoney = this.jian(totalMoney, curDiscountCard.money_reduce);
    } else if (curDiscountCard.activity_type === 2) {
      // 折扣
      let yh = this.cheng(totalMoney, this.jian(1, curDiscountCard.rebate));
      if (curDiscountCard.rebate_limit > 0) {
        if (yh > curDiscountCard.rebate_limit) {
          yh = curDiscountCard.rebate_limit;
        }
      }
      totalMoney = this.jian(totalMoney, yh);
    }
    return totalMoney;
  },
  getDiscountType(arr) {
    let str = "";
    for (let i = 0; i < arr.length; i++) {
      if (arr[i] === 1) {
        str = str + "商品";
      } else if (arr[i] === 2) {
        str = str + "洗美";
      } else if (arr[i] === 3) {
        str = str + "病例";
      } else if (arr[i] === 4) {
        str = str + "疫苗驱虫";
      } else if (arr[i] === 5) {
        str = str + "医疗服务套餐";
      } else if (arr[i] === 6) {
        str = str + "寄养";
      } else if (arr[i] === 7) {
        str = str + "挂号";
      } else if (arr[i] === 8) {
        str = str + "活体";
      } else if (arr[i] === 9) {
        str = str + "虚拟类";
      } else if (arr[i] === 10) {
        str = str + "订金";
      } else {
        str = str + "未知";
      }
      str = str + "/";
    }
    return str.substr(0, str.length - 1);
  },
  getRow(goodsItem, skuItem, wayItem, goodsType) {
    let row = {};
    if (goodsType === 4) {
      row = {
        tableKey: "tableKey" + Math.random(),
        goodsId: goodsItem.serviceId,
        goodsName: goodsItem.title,
        goodsType: 4,
        orderNum: "",
        skuValue: "",
        mprice:skuItem.mprice,
        price: skuItem.price,
        originalPrice: skuItem.price,
        customPrice: skuItem.price,
        minPrice: skuItem.price,
        maxPrice: skuItem.price,
        num: 1,
        goodsUsage: "",
        goodsDosage: "",
        goodsList: [],
        remark: "",
        isPay: false,
        unit: "",
        brand: "",
        categoryId: goodsItem.category_info ? goodsItem.category_info._id : "",
        categoryName: goodsItem.category_info
          ? goodsItem.category_info.name
          : "",
        isNeedCode: goodsItem.use_consumableMaterial_status, // 是否有耗材
        buyBack: goodsItem.buy_back||0,
      };
    } else if (goodsType === 1) {
      row = {
        goodsId: goodsItem.medical_id,
        tableKey: "tableKey" + Math.random(),
        goodsName: goodsItem.title,
        isHumanMedication: goodsItem.is_human_medication,
        otherName: goodsItem.other_name,
        goodsType: goodsType,
        orderNum: "",
        isPay: false,
        model: "",
        num: 1,
        originalPrice: goodsItem.pprice,
        mprice:goodsItem.mprice,
        price: goodsItem.pprice,
        remark: "",
        serviceId: "",
        skuValue: goodsItem.old_packinfo_info.sku_value,
        skus: "",
        totalMoney: goodsItem.pprice,
        unit: goodsItem.old_packinfo_info.in_unit,
        outUnit: goodsItem.old_packinfo_info.unit,
        unit_changedesc: goodsItem.old_packinfo_info.unit_changedesc,
        unit_changesrc: goodsItem.old_packinfo_info.unit_changesrc,
        allow_wholesale: goodsItem.medical_ext_info.allow_wholesale,
        dosageCeiling: goodsItem.medical_ext_info.dosage_ceiling,
        dosageCeilingValue: goodsItem.medical_ext_info.dosage_ceiling_value,
        goodsDosage: 0,
        goodsUsage: "内服",
        lWeightUnit: "mg",
        in_exchanage: goodsItem.old_packinfo_info.in_exchanage,
        stock:
          this.FShopStock(goodsItem.stock_detail)[0] === -1
            ? 0
            : this.FShopStock(goodsItem.stock_detail)[0],
        goodsList: [],
        brand: goodsItem.brand_name,
        categoryId: goodsItem.category_info ? goodsItem.category_info._id : "",
        categoryName: goodsItem.category_info
          ? goodsItem.category_info.name
          : "",
        tags: goodsItem.tags,
        buyBack: goodsItem.buy_back,
        stock_detail: goodsItem.stock_detail,
        old_packinfo_info: goodsItem.old_packinfo_info,
      };
      row.originalPrice = this.getCFPrice(
        row.allow_wholesale,
        row.in_exchanage,
        row.originalPrice
      );
      row.price = this.getCFPrice(
        row.allow_wholesale,
        row.in_exchanage,
        row.price
      );
      row.mprice = this.getCFPrice(
        row.allow_wholesale,
        row.in_exchanage,
        row.mprice
      );
      row.goodsDosage = row.in_exchanage < 1 ? 0 : 1;
      // if(row1.allow_wholesale){
      // 	this.$set(row1,'goodsDosage',row1.allow_wholesale===1?1:0)
      // }
      // 华北 注射用氨苄西林钠 注射类 0.5g/瓶 最大单位出库
    }else if(goodsType===0){
      console.log(goodsItem, skuItem, wayItem,'goodsItemgoodsItemgoodsItem');
      row = {
        tableKey: "tableKey" + Math.random(),
        goodsId: goodsItem.goodsId,
        goodsName: goodsItem.title,
        goodsType: 0,
        orderNum: "",
        skuValue: skuItem.skus_name,
        mprice:skuItem.mprice,
        price: skuItem.price,
        originalPrice: skuItem.price,
        customPrice: skuItem.price,
        minPrice: skuItem.price,
        maxPrice: skuItem.price,
        num: 1,
        goodsUsage: "",
        goodsDosage: "",
        goodsList: [],
        remark: "",
        isPay: false,
        unit: "",
        brand: "",
        stock: skuItem.stock,
        sale_way:skuItem.sale_way,
        sale_way_packing_exchange:skuItem.sale_way_packing_exchange,
        categoryId: goodsItem.category_info ? goodsItem.category_info._id : "",
        categoryName: goodsItem.category_info
          ? goodsItem.category_info.name
          : "",
        isNeedCode: goodsItem.use_consumableMaterial_status, // 是否有耗材
        buyBack: goodsItem.buy_back||0,
      };
    }
    return row;
  },
  FShopStock(arr) {
    let stock = -1;

    if (arr[0] != undefined) {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].shop_id === store.default.state.shopId) {
          stock = arr[i].shop_stock;
  
        }
      }
    }
    return [
      stock,
      // open_count,
      // open_lastTotalTimes,
      // noUse_count,
      // noUse_totalTimes,
    ];
  },
  formatNumTochinese(s_) {
    if (this.isNull(s_)) {
      return "--";
    }
    var _arrayCHNNum = [
      "〇",
      "一",
      "二",
      "三",
      "四",
      "五",
      "六",
      "七",
      "八",
      "九",
    ];
    var _arrayCHNBit = ["", "十", "百", "千"];
    let _numArray = s_.toString().split("");
    if (_numArray.length === 2 && _numArray[0] === "1") {
      _numArray[0] = "y";
    }
    for (let i = _numArray.length - 1; i >= 0; i--) {
      if (_numArray[i] === "0") {
        _numArray[i] = "x";
      } else {
        break;
      }
    }
    let _s = "";
    let _bLast0 = false;
    for (let i = 0; i < _numArray.length; i++) {
      if (_numArray[i] === "x") {
        continue;
      }
      if (_numArray[i] === "0" && _bLast0) {
        _bLast0 = true;
        continue;
      }
      if (_numArray[i] !== "y") {
        //delete 1 in ten
        _s += _arrayCHNNum[parseInt(_numArray[i])];
      }
      if (_numArray[i] === "0") {
        _bLast0 = true;
        continue;
      }
      _bLast0 = false;
      _s += _arrayCHNBit[_numArray.length - i - 1];
    }
    return _s;
  },
  getDiscountByGrades(grades) {
    if (grades === 0) {
      return "";
    } else if (grades === 1) {
      return "95";
    } else if (grades === 2) {
      return "9";
    } else if (grades === 3) {
      return "88";
    } else if (grades === 4) {
      return "85";
    } else if (grades === 5) {
      return "8";
    } else {
      return "";
    }
  },
  base: "/#",
  jia() {
    let re = 0;
    for (let i = 0; i < arguments.length; i++) {
      re = re + Number(arguments[i]);
    }
    return this.toDoubleFixed2(re);
  },
  jian(num1, num2) {
    let re = num1 - num2;
    return this.toDoubleFixed2(re);
  },
  cheng(num1, num2) {
    let re = num1 * num2;
    return this.toDoubleFixed2(re);
  },
  chu(num1, num2) {
    let re = Number(num1) / Number(num2);
    return this.toDoubleFixed2(re);
  },
  jia_1() {
    let re = 0;
    for (let i = 0; i < arguments.length; i++) {
      re = re + Number(arguments[i]);
    }
    return this.toDoubleFixed2_1(re);
  },
  jian_1(num1, num2) {
    let re = num1 - num2;
    return this.toDoubleFixed2_1(re);
  },
  cheng_1(num1, num2) {
    let re = num1 * num2;
    return this.toDoubleFixed2_1(re);
  },
  cheng_2(num1, num2) {
    let re = num1 * num2;
    return re.toFixed(0);
  },
  chu_1(num1, num2) {
    let re = Number(num1) / Number(num2);
    return this.toDoubleFixed2_1(re);
  },
  quyu(num1, num2) {
    let re = parseInt(Number(num1) * 100) % parseInt(Number(num2) * 100);
    return parseInt(re);
  },
  // 获取对象某一项（arr,key,keyvalue）
  getMatchingItem(arr, key, keyValue) {
    for (let i = 0; i < arr.length; i++) {
      if (arr[i][key] == keyValue) {
        return arr[i];
      }
    }
    return {};
  },
  replaceGoodsDosage(value) {
    value = String(value);
    //先把非数字的都替换掉，除了数字和.
    value = value.replace(/[^\d.]/g, "");
    //必须保证第一个为数字而不是.
    value = value.replace(/^\./g, "");
    //保证只有出现一个.而没有多个.
    value = value.replace(/\.{2,}/g, ".");
    //保证.只出现一次，而不能出现两次以上
    value = value
      .replace(".", "$#$")
      .replace(/\./g, "")
      .replace("$#$", ".");
    console.log(value);
    return value;
  },
  FInt(value) {
    value = String(value);
    value = value.replace(/[^\d]/g, "");
    return value;
  },
   // 时间格式化
   timestampToTime(timestamp) {
    var chinaStandard=timestamp;
    var date = new Date(chinaStandard);
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    m = m < 10 ? ('0' + m) : m;
    var d = date.getDate();
    d = d < 10 ? ('0' + d) : d;
    return  y + m + d;
    },
    //取得的值 2021-07-19 11:11:55

  Timer(time) {
    // 时间戳为10位需要*1000，时间戳位13位不需要
    var data = new Date(time);
    var year = data.getFullYear() + "-"; //获取完整年份  4位
    var month =
      (data.getMonth() + 1 < 10
        ? "0" + (data.getMonth() + 1)
        : data.getMonth() + 1) + "-"; //获取月份（0-11） 如果月份小于10显示为01，02
    var day =
      data.getDate() < 10 ? "0" + data.getDate() : data.getDate() + " "; //获取日（1-31）  小于10为01，02
    return year + month + day;
  },
  // 格式化时间（时间戳,'YYYY-MM-DD HH:mm:ss'）
  FTime(str, str2) {
    str = parseInt(str);
    if (!str) return "";
    if (str.toString().length == 10 || str.toString().length == 9) {
      str = parseInt(str + "000");
    }
    if (!str2) {
      str2 = "YYYY-MM-DD HH:mm:ss";
    }
    let date = new moment(parseInt(str));
    let formatDate = date.format(str2);
    return formatDate;
  },
  calculatePetAge(data){
    if (data) {
      var g = data.replace(/-/g, "/")
      var birthday = new Date(g);
      var today = new Date();
      var time = Math.trunc((parseInt((today.getTime() - birthday.getTime()) / (1000 * 3600 * 24)) / 30));
      var year = Math.trunc(time / 365);
      if (time < 12) {
        return [year,time]
      }
      if (time == 12) {
        return [1,0]
      } else {
        var n1 = Math.floor(time / 12);
        var n2 = time % 12;
        return [n1,n2]
      }
    }
},
  // 年龄计算 (时间戳，时间戳)
  FAge(str, n2 = new Date().getTime()) {
    if (!str) return "";
    let d;
    if (str.length) {
      if (parseInt(str) < 10000) {
        d = new Date(str).getTime();
      } else {
        d = new Date(parseInt(str)).getTime();
      }
    } else {
      d = new Date(str).getTime();
    }
    let n1 = d.toString().length < 11 ? d * 1000 : d;
    n2 = n2.toString().length < 11 ? n2 * 1000 : n2;
    // 年月日时分秒
    return [
      new moment.duration(n2 - n1).years(),
      new moment.duration(n2 - n1).months(),
      new moment.duration(n2 - n1).days(),
      new moment.duration(n2 - n1).hours(),
      new moment.duration(n2 - n1).minutes(),
      new moment.duration(n2 - n1).seconds(),
    ];
  },
  // 获取间隔天数
  getIntervalDay(str, n2 = new Date().getTime()) {
    if (!str) return 0;
    let d;
    if (str.toString().length < 11) {
      d = new Date(str * 1000);
    } else {
      d = new Date(str * 1);
    }
    d = new Date(
      d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate()
    ).getTime();
    let n1 = d.toString().length < 11 ? d * 1000 : d;
    n2 = n2.toString().length < 11 ? n2 * 1000 : n2;
    return parseInt(new moment.duration(n2 - n1).asDays());
  },
  // 格式化宠物性别
  FSex(a) {
    if (a[1] === 1) {
      if (a[0] == "公") {
        return "绝育公";
      } else if (a[0] == "母") {
        return "绝育母";
      }
    } else if (a[1] === 0) {
      if (a[0] == "公") {
        return "公";
      } else if (a[0] == "母") {
        return "母";
      }
    }
  },
  // 出生日期计算 (str 月数)
  FBirthday(p) {
    let m = new moment();
    return m.subtract(Number(p), "months").format("YYYY-MM-DD");
  },
  // 手机号
  isTel(tel) {
    if (!/^1[3456789]\d{9}$/.test(tel)) {
      return false;
    } else {
      return true;
    }
  },
  // 验证邮箱
  isMail(mail) {
    var filter = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
    if (filter.test(mail)) {
      return true;
    } else {
      return false;
    }
  },
  // 保留两位小数
  toDoubleFixed2(num) {
    let num1 = Number((num * 100).toFixed(2));
    if (num > 0) {
      return Math.ceil(num1) / 100;
    } else {
      return 0;
    }
  },
  toDoubleFixed2_1(num) {
    let num1 = Number((num * 100).toFixed(2));
    return Math.ceil(num1) / 100;
  },
  // 是否为空
  isNull(str) {
    if (
      str === "" ||
      str === null ||
      str === undefined ||
      (Array.isArray(str) && str.length === 0) ||
     JSON.stringify(str) === '{}'
    ) {
      return true;
    } else {
      return false;
    }
  },
  // 根据时间获取10位时间戳
  FTimeStr10(date) {
    if (this.isNull(date)) {
      return "";
    } else {
      let str = new Date(date).getTime().toString();
      return str.substr(0, str.length - 3);
    }
  },
  // // 判断合单支付时，是否有同样的条码
  // sameCodeAtMergeOrder(orderList) {
  //   console.log(orderList,'orderListorderList');
  //   let allCode = [];
  //   for (let i = 0; i < orderList.length; i++) {
  //     let arr = [];
  //     for (let a = 0; a < orderList[i].order_item_list.length; a++) {
  //       for (
  //         let b = 0;
  //         b < orderList[i].order_item_list[a].order_item_goods_list.length;
  //         b++
  //       ) {
  //         let goods = orderList[i].order_item_list[a].order_item_goods_list[b];
  //         if (arr.indexOf(goods.barCode) === -1) {
  //           arr.push(goods.barCode);
  //         }
  //       }
  //     }
  //     for (let c = 0; c < arr.length; c++) {
  //       allCode.push(arr[c]);
  //     }
  //   }
  //   let res = [];
  //   let obj = allCode.reduce((r, a) => {
  //     r[a] = [...(r[a] || []), a];
  //     return r;
  //   }, {});
  //   for (let z in obj) {
  //     if (obj[z].length > 1) {
  //       res.push(z);
  //     }
  //   }
  //   return res;
  // },
  sumGoodsCount(array) {
    //合计相同商品 和规格下得条码
    var sumGoodsData = [];
    array.forEach((item) => {
      let isDiffIndex = sumGoodsData.findIndex((subitem) => {
        return item.goodsId == subitem.goodsId && item.skus == subitem.skus;
      });
      // 若不相同商品和规格 children 包含商品条码 sumGoodsDataitem包含相同得商品信息
      if (isDiffIndex == -1) {
        sumGoodsData.push({
          goodsId: item.goodsId,
          skus: item.skus,
          goodsName: item.goodsName,
          skuValue: item.skuValue,
          unit: item.unit,
          count: 1,
          children: [item],
        });
      } else {
        sumGoodsData[isDiffIndex].count += 1;
        sumGoodsData[isDiffIndex].children.push(item);
        sortCustom(sumGoodsData[isDiffIndex].children);
      }
    });
    return sumGoodsData;
  },
  dg(list, dictionary) {
    let obj = {};
    for (let i = 0; i < list.length; i++) {
      if (list[i].length === 1) {
        obj[list[i][0]] = [];
      } else {
        if (obj[list[i][0]] === undefined) {
          obj[list[i][0]] = [list[i]];
        } else {
          obj[list[i][0]].push(list[i]);
        }
      }
    }
    for (let key in obj) {
      let list1 = JSON.parse(JSON.stringify(obj[key]));
      list1.map((item) => {
        return item.shift();
      });
      obj[key] = this.dg(list1, dictionary);
    }
    let res = [];
    for (let key in obj) {
      res.push({
        key: key,
        value: dictionary[key],
        child: obj[key],
      });
    }
    return res;
  },
  /*
  @function calculatePetAge
  @params data 
  @description 传入宠物年龄进行判断 30天为一个月
  @return [year,time] 数组中[0]是年 [1]是日
  */

};
function sortCustom(array) {
  return array.sort(function(a, b) {
    return a.customCode - b.customCode;
  });
}
export default pub;
